import chatbot from "./chatbot.routes";
import companies from "./companies.routes";
import feedback from "./feedback.routes";
import integrations from "./integrations.routes";
import listings from "./listings.routes";
import reports from "./reports.routes";

export default {
    chatbot,
    companies,
    feedback,
    integrations,
    listings,
    reports
};
